<template>
  <div>
    <card class="white rounded-lg">
      <v-card-title class="secondary--text">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6"
                 v-for="(row, i) in rows"
                 v-if="row.id">

            <v-card class="rounded-lg tableHeader mt-3 pa-4">
              <v-row>
                <v-col cols="2">
                  <v-avatar color="secondary" class="white--text" size="35">
                    {{ i + 1 }}
                  </v-avatar>
                </v-col>
                <v-col cols="6" class="pt-5">
              <span style="font-size: larger; font-weight: bold">
                {{ row.name }}
              </span>
                </v-col>
                <v-col cols="4" class="pt-4">
                  <v-autocomplete
                      class="rounded-lg"
                      :disabled="!isEditing"
                      :items="boolean_choices"
                      item-text="title"
                      item-value="value"
                      v-model="row.value"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex  justify-md-end">
        <v-btn
            v-if="!isEditing"
            @click="isEditing = true"
            class="rounded-lg white--text"
            depressed
            color="primary"

        >ویرایش</v-btn>
        <v-btn
            v-if="isEditing"
            @click="updateConfigs"
            class="rounded-lg white--text"
            depressed
            color="success"

        >ثبت</v-btn>
      </v-card-actions>
    </card>
  </div>
</template>

<script>
import FormLogic from "./FormLogic";

export default {
  name: "ConfigForm",
  components: {},
  mixins: [FormLogic],
};
</script>

<style scoped lang="scss">
</style>
